// Shows the floating phone Book Tickets button (.book-float in _button.css) only while no other Book
// Tickets button and no booking form is in view, so there's never more than one on screen. Pages
// can have several in-page buttons. The header's own button is left out: on phones it's inside the
// closed menu, and from 1024px, where the header shows it, the floating one is hidden by CSS
export function initBookFloat() {
  const float = document.querySelector("[data-book-float]")

  if (!float) {
    return
  }

  const inView = new Set()
  const update = () => {
    const shown = inView.size === 0
    float.classList.toggle("is-shown", shown)
    // Lets Back to top move out of its way on narrow phones (_button.css)
    document.body.classList.toggle("book-float-shown", shown)
  }

  // A button behind the fixed header is out of view, so leave the header's height off the top
  const header = document.querySelector("#main-header")
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          inView.add(entry.target)
        } else {
          inView.delete(entry.target)
        }
      })

      update()
    },
    { rootMargin: `-${header?.offsetHeight || 0}px 0px 0px 0px` },
  )

  let watching = 0
  document.querySelectorAll("[data-book-tickets]").forEach((button) => {
    if (!button.closest("#main-header")) {
      observer.observe(button)
      watching += 1
    }
  })

  // The booking form is built by Vue after the page starts. #booking-form is an empty link at the
  // top of it, so watch the whole form rather than the link
  const watchForm = () => {
    const anchor = document.getElementById("booking-form")

    if (!anchor) {
      return false
    }

    observer.observe(anchor.closest("aside") || anchor.parentElement)
    watching += 1

    return true
  }

  // Twice a second, for up to 20 seconds on pages that never get one
  if (!watchForm()) {
    let tries = 0
    const look = setInterval(() => {
      tries += 1
      if (watchForm() || tries >= 40) {
        clearInterval(look)
      }
    }, 500)
  }

  // The observer reports each button once it starts watching. With nothing to watch, it never
  // would, so show the button straight away
  if (!watching) {
    update()
  }
}
